import React from 'react';

const Auth = React.createContext({
    user: null,
});

export default Auth;